import { render, staticRenderFns } from "./DoughnutChart.vue?vue&type=template&id=3c91e087&"
import script from "./DoughnutChart.vue?vue&type=script&lang=js&"
export * from "./DoughnutChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c91e087')) {
      api.createRecord('3c91e087', component.options)
    } else {
      api.reload('3c91e087', component.options)
    }
    module.hot.accept("./DoughnutChart.vue?vue&type=template&id=3c91e087&", function () {
      api.rerender('3c91e087', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pages/Widgets/DoughnutChart.vue"
export default component.exports